import { render, staticRenderFns } from "./RelatieDocumenten.vue?vue&type=template&id=3004e166"
import script from "./RelatieDocumenten.vue?vue&type=script&lang=js"
export * from "./RelatieDocumenten.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports